import styled from 'styled-components';

export const WheelCanvasStyle = styled.canvas`
  width: 98%;
  height: 98%;
`;
